var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sweet-modal', {
    ref: "modal",
    attrs: {
      "title": _vm.$Jed.firstUpperTranslate('pick %1$s', null, {
        key: 'index'
      }),
      "hide-close-button": "",
      "blocking": _vm.doBlock,
      "overlay-theme": "dark"
    }
  }, [_c('transition', {
    staticStyle: {
      "padding": "0px 32px"
    },
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c(_vm.step_component, {
    tag: "component",
    attrs: {
      "backTo1Allowed": _vm.previousExist,
      "isAfterLogin": _vm.doBlock,
      "machineID": _vm.childrenContent.machineID,
      "modelID": _vm.childrenContent.modelID,
      "exOnOpen": _vm.exOnOpen,
      "catalogo": _vm.childrenContent.catalogo,
      "modello": _vm.childrenContent.modello
    },
    on: {
      "forward": _vm.stepForward,
      "manuallyOpenCallback": _vm.registerCallback,
      "tryOpenModal": _vm.tryOpenModal,
      "load": _vm.load,
      "backward": _vm.navBackward
    }
  })], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47a9d97c","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loader/ModalSelect.vue
// module id = 1510
// module chunks = 1